import { PageContainer } from '@/components'
import TaskListMain from './task-list-main'
const DataProtectionTaskList: React.FC = () => (
  <PageContainer>
    <TaskListMain />
  </PageContainer>
)
export default DataProtectionTaskList
